<template>
  <div class="gem-page-list" :class="{ 'list-scroll': listType == 'addPages' }">
    <slot name="GpListItem"></slot>
  </div>
</template>

<script>
export default {
  name: "GpList",
  props: {
    listType: String
  },
  data() {
    return {};
  },
  computed: {},
  created() {
    if (this.listType == "addPages") {
      var container = document.querySelector(".gem-page-list.list-scroll");
      if (container) {
        container.addEventListener("scroll", this.calcScroll);
      }
    }
  },
  mounted() {
    if (this.listType == "addPages") {
      var container = document.querySelector(".gem-page-list.list-scroll");
      if (container) {
        container.addEventListener("scroll", this.calcScroll);
      }
    }
  },
  methods: {
    calcScroll() {
      var container = document.querySelector(".gem-page-list.list-scroll");
      if (container) {
        if (container.scrollTop >= container.scrollHeight - container.offsetHeight) {
          this.$emit("doLoadMore");
        }
        // console.log(container.scrollTop);
        // console.log(container.scrollHeight - container.offsetHeight);
      }
    }
  }
};
</script>

<style lang="scss">
@import "./styles.scss";
</style>
